// 날씨 API 파사드 — 좌표 기반으로 국내(기상청) / 해외(Open-Meteo) 분기.
// 소비 컴포넌트는 이 모듈만 import 하며 시그니처는 유지된다.
import * as intl from './weatherApi.intl';
import * as kr from './weatherApi.kr';
import { resolveDomestic } from '../utils/regionState';

// 해외 전용 WMO 변환 유틸 재노출 (하위호환)
export const wmoToSkyPty = intl.wmoToSkyPty;

// 단기예보 (param: {lat, lng})
export const getShortWeather = (param, succFun, failFun) => {
    if (resolveDomestic(param.lat, param.lng)) {
        kr.getShortWeather(param, succFun, failFun);
    } else {
        intl.getShortWeather(param, succFun, failFun);
    }
};

// 중기예보 (param: {lat, lng})
export const getDailyForecast = (param, succFun, failFun) => {
    if (resolveDomestic(param.lat, param.lng)) {
        kr.getDailyForecast(param, succFun, failFun);
    } else {
        intl.getDailyForecast(param, succFun, failFun);
    }
};
